import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  StaffEmployeeRequest,
  StaffEmployeeResponse,
  StaffEmployeeStatus,
} from "../model/employee.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffEmployeesService {
  private readonly employeesUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.employeesUrl = `${basePath.replace(/\/$/, "")}/api/v1/employees`;
  }

  list(
    companyId?: number,
    status?: StaffEmployeeStatus,
  ): Observable<StaffEmployeeResponse[]> {
    let params = new HttpParams();
    if (companyId != null) params = params.set("companyId", companyId);
    if (status) params = params.set("status", status);
    return this.http.get<StaffEmployeeResponse[]>(this.employeesUrl, {
      params,
    });
  }

  getById(employeeId: number): Observable<StaffEmployeeResponse> {
    return this.http.get<StaffEmployeeResponse>(
      `${this.employeesUrl}/${employeeId}`,
    );
  }

  create(request: StaffEmployeeRequest): Observable<StaffEmployeeResponse> {
    return this.http.post<StaffEmployeeResponse>(this.employeesUrl, request);
  }

  update(
    employeeId: number,
    request: StaffEmployeeRequest,
  ): Observable<StaffEmployeeResponse> {
    return this.http.put<StaffEmployeeResponse>(
      `${this.employeesUrl}/${employeeId}`,
      request,
    );
  }

  deactivate(employeeId: number): Observable<void> {
    return this.http.delete<void>(`${this.employeesUrl}/${employeeId}`);
  }

  terminate(employeeId: number): Observable<StaffEmployeeResponse> {
    return this.http.post<StaffEmployeeResponse>(
      `${this.employeesUrl}/${employeeId}/terminate`,
      {},
    );
  }
}
